module.exports = __webpack_public_path__ + "static/media/T2-Heroku.b5ad57cd.svg";